import {Component, Input, OnInit} from "@angular/core";
import {PortalService} from "../../services/portal.service";

@Component({
  selector: 'app-moderat-fernwaerme-teaser',
  templateUrl: './fernwaerme.teaser.component.html',
  standalone: false
})

export class FernwaermeTeaserComponent implements OnInit {
  /**
   * Textkeyprefix for the used texts
   */
  @Input() textkeyPrefix: string;

  /**
   * Textkeypostfix for the used texts
   */
  @Input() textkeyPostfix: string;

  /**
   * Indicates whether an image is available or enabled.
   */
  @Input() imagePath?: string;

  /**
   * Teaser Topic used for individual textkeys for each teaser
   */
  @Input() teaserTopic: string;

  /**
   * CSS class for the teaser to use custom styling
   */
  @Input() teaserClass: string;

  /**
   * CSS class for the button to use custom button/styling
   */
  @Input() buttonClass?: string;

  /**
   * Toggle for the download icon place in the button
   */
  @Input() downloadIcon?: boolean;

  /**
   * Toggle for showing/hiding the badge
   */
  @Input() showBadge: boolean = false;

  /**
   * Toggle for showing/hiding the logo on top
   */
  @Input() showLogo: boolean;

  /**
   * Path to the logo
   */
  logoPath: string;

  /**
   * Toggle if this is an internal portal or not
   */
  isInternalPortal: boolean;

  /**
   * constructor
   */
  constructor(private portalService: PortalService) {}

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
   this.isInternalPortal = this.portalService.getConfigAsBool('embed.internal.portal');

   // get the portal specific path for the logo on top of teaser
   const portalId = this.portalService?.currentPortalId;
   this.logoPath = '/gfx/portale/' + portalId + '/consultancy_logo.svg';
  }
}
